export const QUESTIONNAIRE_FORM = 'QUESTIONNAIRE_FORM';
export const QUESTIONNAIRE_FEEDBACK_FORM = 'QUESTIONNAIRE_FEEDBACK_FORM';
export const CHECK_ANSWERS_MODAL = 'CHECK_ANSWERS_MODAL';
export const FEEDBACK_MODAL = 'FEEDBACK_MODAL';

export const CYSEC_QUESTIONNAIRE_BLOCKED_DAYS = 30;

export const CYSEC_QUESTIONNAIRE_TYPE = {
  EXPERIENCE: 'experience',
  KNOWLEDGE_RISK_TOLERANCE: 'risk_tolerance',
  FINANCIAL_SITUATION: 'financial_situation',
};
export const CYSEC_QUESTIONNAIRE_CATEGORY = {
  TRADING_EXPERIENCE: 'trading_experience',
  ENVESTMENT_KNOWLEDGE: 'investment_knowledge',
  EMPLOYMENT: 'employment',
  PROFESSIONAL_EXPERIENCE: 'professional_experience',
  INVESTMENT_OBJECTIVES: 'investment_objectives',
  EMPLOYMENT_STATUS: 'employment_status',
  FINANCIAL_DETAILS: 'financial_details',
};

export const QUESTIONNAIRE_CONFIG = [
  {
    type: CYSEC_QUESTIONNAIRE_TYPE.EXPERIENCE,
    categories: [CYSEC_QUESTIONNAIRE_CATEGORY.TRADING_EXPERIENCE],
    header: {
      imageThemeKey: 'cySecVerification.questionnaire.tradingExperience.avatar',
      subtitle:
        'We need to assess your knowledge of financial products. Any incorrect answer may fail your assessment. Please consider your responses carefully.',
    },
  },
  {
    type: CYSEC_QUESTIONNAIRE_TYPE.EXPERIENCE,
    categories: [CYSEC_QUESTIONNAIRE_CATEGORY.ENVESTMENT_KNOWLEDGE],
    header: {
      imageThemeKey: 'cySecVerification.questionnaire.investmentKnowledge.avatar',
    },
  },
  {
    type: CYSEC_QUESTIONNAIRE_TYPE.KNOWLEDGE_RISK_TOLERANCE,
    categories: [
      CYSEC_QUESTIONNAIRE_CATEGORY.EMPLOYMENT,
      CYSEC_QUESTIONNAIRE_CATEGORY.PROFESSIONAL_EXPERIENCE,
      CYSEC_QUESTIONNAIRE_CATEGORY.INVESTMENT_OBJECTIVES,
    ],
    header: {
      imageThemeKey: 'cySecVerification.questionnaire.knowledgeRiskTolerance.avatar',
    },
  },
  {
    type: CYSEC_QUESTIONNAIRE_TYPE.FINANCIAL_SITUATION,
    categories: [CYSEC_QUESTIONNAIRE_CATEGORY.EMPLOYMENT_STATUS],
    header: {
      imageThemeKey: 'cySecVerification.questionnaire.financialSituation.avatar',
    },
  },
  {
    type: CYSEC_QUESTIONNAIRE_TYPE.FINANCIAL_SITUATION,
    categories: [CYSEC_QUESTIONNAIRE_CATEGORY.FINANCIAL_DETAILS],
    header: {
      imageThemeKey: 'cySecVerification.questionnaire.financialSituation.avatar',
    },
  },
];

export const QUESTIONNAIRE_TEXT_MAPPER = {
  TYPES: {
    [CYSEC_QUESTIONNAIRE_TYPE.EXPERIENCE]: 'Experience',
    [CYSEC_QUESTIONNAIRE_TYPE.KNOWLEDGE_RISK_TOLERANCE]: 'Knowledge/Risk Tolerance',
    [CYSEC_QUESTIONNAIRE_TYPE.FINANCIAL_SITUATION]: 'Financial Situation',
  },
  CATEGORIES: {
    [CYSEC_QUESTIONNAIRE_CATEGORY.TRADING_EXPERIENCE]: 'Trading Experience',
    [CYSEC_QUESTIONNAIRE_CATEGORY.ENVESTMENT_KNOWLEDGE]: 'Investment Knowledge',
    [CYSEC_QUESTIONNAIRE_CATEGORY.EMPLOYMENT]: 'Employment',
    [CYSEC_QUESTIONNAIRE_CATEGORY.PROFESSIONAL_EXPERIENCE]: 'Professional Experience',
    [CYSEC_QUESTIONNAIRE_CATEGORY.INVESTMENT_OBJECTIVES]: 'Investment Objectives',
    [CYSEC_QUESTIONNAIRE_CATEGORY.EMPLOYMENT_STATUS]: 'Financial Details',
    [CYSEC_QUESTIONNAIRE_CATEGORY.FINANCIAL_DETAILS]: 'Financial Details',
  },
};

export const SCORE = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const QUESTIONNAIRE_FEEDBACK_CONFIG = {
  [SCORE.HIGH]: {
    title: 'profile:cySecVerification.questionnaire.high.title',
    imageThemeKey: 'cySecVerification.questionnaire.high.avatar',
    buttonText: 'profile:cySecVerification.questionnaire.high.buttonText',
    message: 'profile:cySecVerification.questionnaire.high.message',
  },
  [SCORE.MEDIUM]: {
    title: 'profile:cySecVerification.questionnaire.medium.title',
    imageThemeKey: 'cySecVerification.questionnaire.medium.avatar',
    buttonText: 'profile:cySecVerification.questionnaire.medium.buttonText',
  },
  [SCORE.LOW]: {
    title: 'profile:cySecVerification.questionnaire.low.title',
    imageThemeKey: 'cySecVerification.questionnaire.low.avatar',
    buttonText: 'profile:cySecVerification.questionnaire.low.buttonText',
    message: 'profile:cySecVerification.questionnaire.low.message',
  },
};

export const ALPHABETICAL_LIST = ['a)', 'b)', 'c)', 'd)'];
